import React from "react";
import CrudPage from "../components/CrudPage";

const fields = [
  { key: "title", label: "Project Title", placeholder: "Business E-Commerce Store" },
  { key: "category", label: "Category", placeholder: "Web / Mobile / Marketing / Strategy / Hosting / Social Media" },
  { key: "tag", label: "Tech Tag", placeholder: "React + Node.js" },
  { key: "emoji", label: "Emoji", placeholder: "🛒" },
  { key: "color", label: "Accent Color", type: "color" },
  { key: "desc", label: "Description", type: "textarea" },
  { key: "client", label: "Client", placeholder: "Retail Client, Delhi" },
  { key: "duration", label: "Duration", placeholder: "6 weeks" },
  { key: "order", label: "Display Order", type: "number", min: 0 },
];

const renderCard = (item) => (
  <div>
    <div className="h-20 rounded-xl flex items-center justify-center text-4xl mb-3"
      style={{ background: `${item.color || "#0ea5e9"}15` }}>
      {item.emoji || "📁"}
    </div>
    <div className="flex items-center justify-between mb-1">
      <h3 className="text-white font-bold text-sm">{item.title}</h3>
      <span className="text-xs px-2 py-0.5 rounded-full"
        style={{ background: `${item.color || "#0ea5e9"}20`, color: item.color || "#0ea5e9" }}>
        {item.category}
      </span>
    </div>
    <p className="text-gray-400 text-xs line-clamp-2">{item.desc}</p>
    <div className="flex gap-3 mt-2 text-xs text-gray-500">
      <span>{item.client}</span>
      <span>•</span>
      <span>{item.duration}</span>
    </div>
  </div>
);

export default function PortfolioPage() {
  return <CrudPage title="Portfolio" endpoint="portfolio" fields={fields} renderCard={renderCard} />;
}
